
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/[shopName]",
      function () {
        return require("private-next-pages/shop/[shopName]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/[shopName]"])
      });
    }
  